import { Radio, Segmented, Tabs } from "antd";
import ProfileInfo from "./profile_info";
import LeftOver from "./left_over";
import HistoryPurchase from "./history_purchase";
import "./tabs.scss";
import { useState } from "react";

const ViewPurchase = ({ sppurchaseid = null, msisdn = 0, type = null }) => {
  const [tabSelected, setTabSelected] = useState("profile");

  return (
    <>
      <div className="holder-tab">
        <Segmented
          className="segment-class"
          onChange={(value) => setTabSelected(value)}
          options={[
            { label: "اطلاعات مشترک", value: "profile" },
            { label: "سوابق", value: "history" },
            { label: "باقیمانده", value: "leftover" },
          ]}
          size="large"
          block
        />
        {tabSelected === "profile" && <ProfileInfo sppurchaseid={sppurchaseid} />}
        {tabSelected === "history" && <HistoryPurchase sppurchaseid={sppurchaseid} />}
        {tabSelected === "leftover" && <LeftOver sppurchaseid={sppurchaseid} msisdn={msisdn} type={type} />}
      </div>
    </>
  );
};

export default ViewPurchase;
